import React from 'react';
import Input from '../Input';
import styled from 'styled-components';
const StyledInput = styled(Input) `
  width: ${props => props.width};
  border-radius: 4px;
`;
const Search = ({ placeholder, value, onChange, automationId, width = '500px' }) => (<StyledInput placeholder={placeholder} value={value} onChange={onChange} automationId={automationId} width={width}/>);
export default Search;
